
import React from "react";
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';

export default function ZoomBar({zoom, onChange}: {zoom: number[] , onChange?: (value: number[]) => void}) {

    const handleWheel = (event: React.WheelEvent<HTMLDivElement>) => {
        let delta = Math.abs(event.deltaY) / 100
        if (event.deltaY < 0 && zoom[0] < zoom[1] - 6) {
            onChange([zoom[0] + delta, zoom[1] - delta])
        } else {
            onChange([zoom[0] - (zoom[0] > 0 ? delta: 0), zoom[1] + (zoom[1] < 100 ? delta : 0)])
        }
    };

    return <div onWheel={handleWheel}>
        <RangeSlider id="range-slider" value={zoom} onInput={e => onChange(e)} />
    </div>
}